"use client";

// packages/eden-media-query/src/index.jsx
import { useState, useEffect, useRef } from "react";
var MediaQuery = ({
  media = "(min-width: 0px)",
  defaultMatches = true,
  onChange = () => null,
  render = () => null
}) => {
  const [matches, mediaQuery] = useMediaQuery(onChange, media, defaultMatches);
  return render({ matches, media: mediaQuery });
};
MediaQuery.displayName = "MediaQuery";
var useMediaQuery = (onChange, media = "(min-width: 0px)", defaultMatches = true) => {
  const [matches, setMatches] = useState(defaultMatches);
  const mql = useRef(null);
  useEffect(() => {
    const update = ({ matches: updateMatches }) => {
      setMatches(updateMatches);
      onChange({ matches: updateMatches, media });
    };
    if (window.matchMedia) {
      mql.current = window.matchMedia(media);
      mql.current.addListener(update);
      update(mql.current);
    } else {
      update({ matches });
    }
    return () => {
      mql?.current?.removeListener(update);
      mql.current = null;
    };
  }, [matches, media, onChange]);
  return [matches, media];
};
export {
  MediaQuery,
  useMediaQuery
};
